import { useState, useEffect } from "react";
import axios from "axios";

export const useProductSearch = () => {
  const [filteredProducts, setFilteredProducts] = useState([]);

  useEffect(() => {
    axios
      .get("search-products-list", {
        params: { keyword: "" },
      })
      .then((res) => {
        setFilteredProducts(res.data?.products || []);
      })
      .catch((error) => {
        console.error("Error fetching initial products:", error);
      });
  }, []);

  const searchProduct = async (val, selectedProductIds = []) => {
    try {
      const response = await axios.get("search-products-list", {
        params: {
          keyword: val,
          product_ids: selectedProductIds.map((p) => p.id),
        },
      });
      const products = response.data?.products || [];
      if (val === "") {
        setFilteredProducts(products);
      }
      return products;
    } catch (error) {
      console.error("Error searching products:", error);
      return [];
    }
  };

  const updateFilteredProducts = (newProducts) => {
    setFilteredProducts((prev) => {
      const merged = [...prev, ...newProducts];
      const uniqueProducts = Array.from(
        new Map(merged.map((p) => [p.id, p])).values()
      );
      return uniqueProducts;
    });
  };

  return { filteredProducts, searchProduct, updateFilteredProducts };
};
